import '../scss/style.scss';

// Global event handlers
document.addEventListener('DOMContentLoaded', function () {

  //contact modal
  const btn = document.querySelector(".contact-btn");
  const contact_modal = document.querySelector(".contact-modal");
  if (btn) {
    // Adjust the top of .contact-modal according to the height of header .elementor-sticky
    function adjustContactModalTop() {
      const stickyHeader = document.querySelector('header > .elementor-element');
      if (stickyHeader && contact_modal) {
        const headerHeight = stickyHeader.offsetHeight;
        contact_modal.style.top = headerHeight + 'px';
      } else if (contact_modal) {
        contact_modal.style.top = '0px'; // fallback
      }
    }

    // Run on load
    adjustContactModalTop();
    contact_modal.classList.remove("element-hidden");

    // Also run on resize and scroll (in case the sticky header changes)
    window.addEventListener('resize', adjustContactModalTop);
    window.addEventListener('scroll', adjustContactModalTop);

  
    btn.addEventListener("click", function () {
      contact_modal.classList.toggle("open");
      //document.querySelector("body").classList.toggle("dialog-prevent-scroll");
    });

    // Close the modal when clicking outside the container
    document.addEventListener('click', function (event) {
      // Only if the modal is open
      if (contact_modal.classList.contains("open")) {
        // If the click is outside the modal and outside the button that opens it
        if (
          !contact_modal.contains(event.target) &&
          !btn.contains(event.target)
        ) {
          contact_modal.classList.remove("open");
          //document.querySelector("body").classList.remove("dialog-prevent-scroll");
        }
      }
    });
  }

  // Smooth scroll to anchor elements considering the sticky header height
  document.querySelectorAll('div[data-anchor]').forEach(function(anchorDiv) {
    anchorDiv.addEventListener('click', function(e) {
      // Get the target id from data-anchor attribute
      const targetId = anchorDiv.getAttribute('data-anchor');
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        // Get sticky header height if visible
        const stickyHeader = document.querySelector('header > .elementor-element');
        const headerHeight = stickyHeader ? stickyHeader.offsetHeight : 0;
        // Calculate the scroll position
        const elementRect = targetElement.getBoundingClientRect();
        const absoluteTop = window.pageYOffset + elementRect.top;
        const scrollToPosition = absoluteTop - headerHeight;
        // Smooth scroll to the calculated position
        // Use a "slow" smooth scroll by animating scroll position manually
        // Faster smooth scroll: finish in about 0.03s (30ms)
        const duration = 40; // ms
        const startScroll = window.pageYOffset;
        const distance = scrollToPosition - startScroll;
        const startTime = performance.now();

        function fastScrollStep(now) {
          const elapsed = now - startTime;
          if (elapsed >= duration) {
            window.scrollTo(0, scrollToPosition);
            return;
          }
          const progress = elapsed / duration;
          // Ease-in-out (optional): use progress for smoother accel/decel
          const eased = 0.5 * (1 - Math.cos(Math.PI * progress));
          const next = startScroll + distance * eased;
          window.scrollTo(0, next);
          requestAnimationFrame(fastScrollStep);
        }
        requestAnimationFrame(fastScrollStep);
        e.preventDefault();
      }
    });
  });

  if (document.querySelector('.quixote-filter-container')) {
    const mq = window.matchMedia('(max-width: 768px)');
    if (mq.matches) {
      setTimeout(() => {
        document.querySelectorAll('.quixote-filter-container .quixote-main-filter .elementor-widget-n-accordion .e-n-accordion-item[open]').forEach(el =>
          el.removeAttribute('open')
        );
      });
    }
  }
}); 


// Observer to add SVG to new Instagram posts
(function() {
  const svgString = `
    <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 239 16" fill="none">
      <path d="M4.6582 16L238.658 -1.74214e-07L0.658205 -2.09808e-05L4.6582 16Z" fill="#0693E4"/>
    </svg>
  `;

  function appendSVGToTile(tile) {
    // Check if element exists and doesn't already have SVG
    if (!tile || !tile.querySelector || tile.querySelector('.quixote-instagram-svg')) {
      return;
    }
    
    const wrapper = document.createElement('div');
    wrapper.className = 'quixote-instagram-svg';
    wrapper.innerHTML = svgString;
    tile.appendChild(wrapper);
  }

  function processNewTiles(container) {
    // Find all tiles that don't have SVG
    const tiles = container.querySelectorAll('.eapps-instagram-feed-posts-item-template-tile');
    tiles.forEach(tile => {
      if (!tile.querySelector('.quixote-instagram-svg')) {
        appendSVGToTile(tile);
      }
    });
  }

  function observeInstagramFeed(feed) {
    // Process existing tiles
    processNewTiles(feed);

    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) {
            // If a tile is added directly
            if (node.classList.contains('eapps-instagram-feed-posts-item-template-tile')) {
              appendSVGToTile(node);
            }
            // If a container with tiles inside is added
            else if (node.querySelector) {
              const newTiles = node.querySelectorAll('.eapps-instagram-feed-posts-item-template-tile');
              newTiles.forEach(tile => {
                if (!tile.querySelector('.quixote-instagram-svg')) {
                  appendSVGToTile(tile);
                }
              });
            }
          }
        });
      });
    });

    observer.observe(feed, { 
      childList: true, 
      subtree: true 
    });
  }

  function initInstagramObserver() {
    const feeds = document.querySelectorAll('.quixote-instagram-feed');
    feeds.forEach(observeInstagramFeed);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInstagramObserver);
  } else {
    initInstagramObserver();
  }

  // Also observe body changes in case feeds are added dynamically
  const bodyObserver = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          // If an Instagram feed is added
          if (node.classList && node.classList.contains('quixote-instagram-feed')) {
            observeInstagramFeed(node);
          }
          // If a container that might have feeds is added
          else if (node.querySelector) {
            const newFeeds = node.querySelectorAll('.quixote-instagram-feed');
            newFeeds.forEach(observeInstagramFeed);
          }
        }
      });
    });
  });

  bodyObserver.observe(document.body, { 
    childList: true, 
    subtree: true 
  });
})();



window.goToTop = function goToTop(selector) {
  const targetElement = document.querySelector(selector);
  // Get sticky header height if visible
  const stickyHeader = document.querySelector('header > .elementor-element');
  const headerHeight = stickyHeader ? stickyHeader.offsetHeight : 0;
  // Calculate the scroll position
  const elementRect = targetElement.getBoundingClientRect();
  const absoluteTop = window.pageYOffset + elementRect.top;
  const scrollToPosition = absoluteTop - headerHeight;
  // Smooth scroll to the calculated position
  // Use a "slow" smooth scroll by animating scroll position manually
  // Faster smooth scroll: finish in about 0.03s (30ms)
  const duration = 40; // ms
  const startScroll = window.pageYOffset;
  const distance = scrollToPosition - startScroll;
  const startTime = performance.now();

  function fastScrollStep(now) {
  const elapsed = now - startTime;
  if (elapsed >= duration) {
      window.scrollTo(0, scrollToPosition);
      return;
  }
  const progress = elapsed / duration;
  // Ease-in-out (optional): use progress for smoother accel/decel
  const eased = 0.5 * (1 - Math.cos(Math.PI * progress));
  const next = startScroll + distance * eased;
  window.scrollTo(0, next);
  requestAnimationFrame(fastScrollStep);
  }
  requestAnimationFrame(fastScrollStep);
}